module.exports = __webpack_public_path__ + "static/media/gotham_extralight.d449b49d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/Assets/Fonts/gotham_extralight.woff
// module id = 378
// module chunks = 7